import { Link } from 'react-router-dom';
import genericThumb3 from '@/assets/images/generic_thumb_3.png';
import { HelpItem } from '@/core/domain/helpcenter/HelpItems/HelpItems.types';

import './style.less';

interface HelpItemCardProps {
  helpItem?: HelpItem;
  showThumbnail?: boolean;
}

function HelpItemCard({
  helpItem,
  showThumbnail: showThumnail = false,
}: HelpItemCardProps) {
  return (
    <Link to={`/helpCenter/${helpItem?.area.id}/${helpItem?.id}`}>
      <div className="area-item" data-showThumbnail={showThumnail}>
        <span className="name">{helpItem?.title}</span>

        {showThumnail && <img src={helpItem?.thumbnail || genericThumb3} />}
      </div>
    </Link>
  );
}

export default HelpItemCard;
